import { webApiRoute } from '@crm/shared/api';

export const userApiRoutes = {
    getUserDataRoute: () => webApiRoute('crm/get-user-data'),
};
